export function scrollToAnchor(hash: string) {
  if (window.location.hash === hash) {
    const el = document.getElementById(hash.slice(1));
    if (el) {
      let headerHeight = 0;
      const header = document.querySelector('header');
      if (header) headerHeight = header.clientHeight;
      const domRect = el.getBoundingClientRect();

      window.scrollTo({
        top: domRect.top + document.documentElement.scrollTop - headerHeight,
        left: domRect.left + document.documentElement.scrollLeft,
        behavior: 'smooth',
      });
    }
  }
}
